export default class ProjectManagerRepo {
	constructor({ supaTo, supabaseClientFactory, _ }) {
		this.supaTo = supaTo;
		this.supabase = supabaseClientFactory;
		this._ = _;
	}

	async getProjectManagerById(id) {
		if (!id) {
			throw new Error('id is required for get Project Manager by id');
		}
		const [error, data] = await this.supaTo(
			this.supabase
				.from('project_manager')
				.select('*')
				.match({ id }),
		);
		if (error) {
			throw error;
		} else {
			return this._.get(data, 'data[0]', null);
		}
	}

	async getProjectManagers() {
		const [error, data] = await this.supaTo(
			this.supabase
				.from('project_manager')
				.select('*'),
		);
		if (error) {
			throw error;
		} else {
			return this._.get(data, 'data', []);
		}
	}
}
